import * as React from 'react'

import SvgIcon, { SvgIconProps } from '../../SvgIcon'

const SecurityIcon: React.FC<React.PropsWithChildren<SvgIconProps>> = (props) => (
  <SvgIcon viewBox="0 0 15 20" {...props}>
    <path d="M13.707 7.752h-.375v-1.75c0-3.239-2.569-5.943-5.78-6a13.001 13.001 0 0 0-.35 0c-3.212.057-5.781 2.761-5.781 6v1.75h-.374C.47 7.752 0 8.346 0 9.08v8.78c0 .733.47 1.334 1.047 1.334h12.66c.576 0 1.046-.6 1.046-1.335V9.08c0-.734-.47-1.328-1.046-1.328zm-5.144 5.71v2.653c0 .303-.255.56-.559.56H6.75a.566.566 0 0 1-.558-.56v-2.653a1.579 1.579 0 0 1-.467-1.136c0-.841.65-1.564 1.477-1.597a5.86 5.86 0 0 1 .351 0c.827.033 1.477.756 1.477 1.597 0 .444-.172.846-.466 1.136zm2.304-5.71H3.886v-1.75c0-1.93 1.567-3.524 3.49-3.524 1.924 0 3.491 1.595 3.491 3.523v1.75z" />
  </SvgIcon>
)

export default SecurityIcon
